var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.linkType === 'story')?_c('nuxt-link',{attrs:{"data-external":"rich-text-display-link","target":_vm.target,"to":_vm.href}},[_vm._t("default")],2):(_vm.linkType === 'email')?_c('a',{attrs:{"href":`mailto:${_vm.href}`}},[_vm._t("default")],2):_c('a',{attrs:{"href":_vm.href,"target":_vm.target}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }